import createScript from './createScript';
import { Conf } from '../../utils';
import { forwardRef, useCallback, useEffect, useImperativeHandle, useState } from 'react';
import { Spin } from 'antd';

export interface IUeditorProps {
	id?: string;
	ajaxUrl?: string;
	width?: string;
	height?: string;
	autoHeight?: boolean;
	inModal?: boolean;
	toolbarsType?: 'mini' | 'all';
	content?: any;
	handleChange?: Function;
}
type IUeditor = React.PropsWithChildren<IUeditorProps>

const LuckUeditor = (props: IUeditor, ref: any) => {
	const [loading, setLoading] = useState(false);
	const [editor, setEditor] = useState<any>(null);

	const width = props.width || '100%';
	const height = props.height || '400';
	const autoHeight = props.autoHeight || false;
	const content = props.content || '';
	const inModal = props.inModal || false;

	//加载百度js

	const initUE = useCallback(() => {
		const obj: any = window;
		const baseURL = `/js/plugins/ueditor/`;
		let UE = obj['UE'];
		let teditor = {};

		const tbs = props.toolbarsType === 'all' ? Conf.sys.ueditorAll : Conf.sys.ueditorMini

		if (props.id) {
			try {
				UE.delEditor(props.id);
			} catch (e) { }

			const ue = teditor = UE.getEditor(props.id, {
				UEDITOR_HOME_URL: baseURL,
				serverUrl: props.ajaxUrl + 'ueditor',
				initialFrameWidth: width,
				initialFrameHeight: height,
				autoHeightEnabled: autoHeight,
				zIndex: inModal ? 1001 : 999,
				autoFloatEnabled: !inModal,
				removeFormatAttributes: 'lang, align, hspace, valign',
				toolbars: tbs,
				allowDivTransToP: false,
			});

			ue.ready(() => {
				if (content) {
					setTimeout(() => {
						let con = content;
						con = con.replace(/crossorigin="anonymous"/g, '');
						ue.setContent(con);
					}, 100)
				}
				setLoading(false)
				setEditor(teditor)
			});
			//事件selectionChange 
			// ue.addListener("contentChange",function(){
			//     props.handleChange && props.handleChange(ue.getContent());
			// });
			// ue.addListener("blur",function(){
			//     props.handleChange && props.handleChange(ue.getContent());
			// });
		}
	}, [props.toolbarsType, props.id, props.ajaxUrl, width, height, autoHeight, inModal, content])

	useEffect(() => {
		if (editor && editor.setContent) {
			let con = content;
			con = con.replace(/crossorigin="anonymous"/g, '');
			editor.setContent(con);
		}
	}, [content, editor])


	useEffect(() => {
		if (editor && editor['key']) {
			editor.addListener("contentChange", function () {
				let con = editor.getContent();
				con = con.replace(/crossorigin="anonymous"/g, '');
				props.handleChange && props.handleChange(con);
			});
			editor.addListener("blur", function () {
				let con = editor.getContent();
				con = con.replace(/crossorigin="anonymous"/g, '');
				props.handleChange && props.handleChange(con);
			});
		}
	}, [content, editor, props])

	const loadUE = useCallback(() => {
		const url = `/js/plugins/ueditor/ueditor.all.js`;
		const configUrl = `/js/plugins/ueditor/ueditor.config.js`;
		const langUrl = `/js/plugins/ueditor/lang/zh-cn/zh-cn.js`;

		/*
			::this.initUE
			等同于
			this.initUE.bind(this)
		*/
		// 顺序很重要~
		createScript(configUrl, () => {
			createScript(url, () => {
				createScript(langUrl, initUE);
			});
		});
	}, [initUE]);

	useEffect(() => {
		const obj: any = window;
		if (!('baidu' in obj) || !('editor' in obj['baidu'])) {
			loadUE();
			setLoading(true)
		} else {
			initUE();
		};
		return () => {
			editor && editor.destroy && editor.destroy();
			setEditor(null);
		}
		//initUE, loadUE
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useImperativeHandle(ref, () => ({
		getUEContent: () => {
			return editor.getContent() //获取编辑器内容
		}
	}))

	return (
		//name={props.id}
		<Spin spinning={loading}>
			<textarea id={props.id} name={props.id} ></textarea>
		</Spin>
	)
}
//withXiumi: false,
export default forwardRef(LuckUeditor);